import { useEffect } from 'react';

const Head = () => {
	useEffect(() => {
		let meta = document.querySelector('meta[name="viewport"]');
		if (!meta) {
			meta = document.createElement('meta');
			meta.setAttribute('name', 'viewport');
			document.head.appendChild(meta);
		}
		meta.setAttribute('content', 'width=device-width, initial-scale=1');
	}, []);

	return <></>;
};

export default Head;
